import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { SubNavigation } from "../support/security";
import Crusaders from "./components/crusaders";
import Chat from "./components/chats"
import YearPicker from "../scholarship/YearPicker";

import "./index.css";

const Messaging = ({ location, topUser }) => {

    const [scholarship, setScholarship] = useState(null);
    if (topUser.userProfile.userType == 10 && location.pathname === "/messages") {
        return <Redirect to="/messages/chat" />;
    }
    if (location.pathname === "/messages") {
        return <Redirect to="/messages/crusaders" />;
    }
    return (
        <div className="messaging-main">
            <div className="scholarship-year-container">
                <YearPicker
                    onSelectChange={(s) => {
                        setScholarship(s);
                    }}
                />
            </div>
            <div className="messaging-main-nav">
                <SubNavigation sectionName="Messages" />
            </div>
            <Route path="/messages/crusaders" render={() => <Crusaders scholarship={scholarship} />} />
            <Route path="/messages/chat" render={() => <Chat />} />
        </div>
    );
};

export default Messaging;
